import { TProductFile } from 'feature/appeals/type'
import { convertBytesToString } from 'helpers/convertBytesToString'

import style from './AppealFileList.module.scss'

export const AppealFileList = ({ files }: { files: TProductFile[] }) => {
  return (
    <div className={style.fileList}>
      {files.map(file => (
        <div className={style.file} key={file.url}>
          <div className={style.fileInf}>
            <img src={file.url} alt={file.filename} />
            <div className={style.fileTextInf}>
              <span className={style.fileName}>{file.filename}</span>
              <span className='caption'>{convertBytesToString(file.size)}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
